import React, { useState } from 'react';
import { Settings as SettingsIcon, Clock, Building, Users, BookOpen, Grid, Link } from 'lucide-react';
import '../styles/Settings.css';

// Import smaller setting components
import TimetableSettings from './settings/TimetableSettings';
import RoomSettings from './settings/RoomSettings';
import TeacherSettings from './settings/TeacherSettings';
import ClassSettings from './settings/ClassSettings';
import SubjectSettings from './settings/SubjectSettings';
import AssociatedSubjectSettings from './settings/AssociatedSubjectSettings';

const Settings = ({ onNext }) => {
  const [currentSetting, setCurrentSetting] = useState('timetable');
  
  const settingsTabs = [
    { id: 'timetable', name: '時間表設定', icon: Clock },
    { id: 'rooms', name: '課室設定', icon: Building },
    { id: 'teachers', name: '教師設定', icon: Users },
    { id: 'classes', name: '班別設定', icon: BookOpen },
    { id: 'subjects', name: '科目設定', icon: Grid },
    { id: 'associated-subjects', name: '相連科目設定', icon: Link }
  ];

  const renderCurrentSetting = () => {
    switch (currentSetting) {
      case 'timetable':
        return <TimetableSettings />;
      case 'rooms':
        return <RoomSettings />;
      case 'teachers':
        return <TeacherSettings />;
      case 'classes':
        return <ClassSettings />;
      case 'subjects':
        return <SubjectSettings />;
      case 'associated-subjects':
        return <AssociatedSubjectSettings />;
      default:
        return <TimetableSettings />;
    }
  };

  return (
    <div className="settings-container">
      {/* Header Section */}
      <div className="settings-header">
        <div className="settings-header-content">
          <div className="settings-icon-container">
            <SettingsIcon className="settings-icon" size={24} />
          </div>
          <div className="settings-title-section">
            <h3 className="settings-title">設定 (Settings)</h3>
            <p className="settings-subtitle">時間表、課室、教師、班別與科目設定</p>
          </div>
        </div>
      </div>

      {/* Settings Navigation */}
      <div className="settings-navigation">
        <div className="settings-tabs-container">
          {settingsTabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setCurrentSetting(tab.id)}
                className={`settings-tab ${currentSetting === tab.id ? 'active' : ''}`}>
                <div className="settings-tab-icon">
                  <Icon size={18} />
                </div>
                <span className="settings-tab-text">{tab.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      {renderCurrentSetting()}

      <div className="flex justify-between items-center pt-6 border-t border-gray-200">
        <button className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200 font-medium">
          關閉 (Close)
        </button>
        <div className="flex space-x-3">
          <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 font-medium">
            編修 (Modify)
          </button>
          <button className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all duration-200 font-medium">
            儲存 (Save)
          </button>
          <button 
            onClick={() => onNext('planning')}
            className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 font-medium flex items-center">
            下一步：計劃資料 (Next: Planning Data)
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;